import { useLingui } from '@lingui/react/macro';
import { animated, easings, useSpring } from '@react-spring/web';
import type { FC } from 'react';
import { cn } from '@/shared/react';

export const HeroTexts: FC<{ className?: string }> = ({ className }) => {
  const { t } = useLingui();

  // top small subtitle
  const subtitle = useSpring({
    from: { y: 15, opacity: 0 },
    to: { y: 0, opacity: 1 },
    delay: 200,
    config: { easing: easings.easeOutCubic },
  });

  // h1
  const h1 = useSpring({
    from: { y: 10, opacity: 0, filter: 'blur(4px)' },
    to: { y: 0, opacity: 1, filter: 'blur(0px)' },
    delay: 700,
    config: { duration: 500, easing: easings.easeOutCubic },
  });

  // bottom paragraph
  const paragraph = useSpring({
    from: { y: 10, opacity: 0 },
    to: { y: 0, opacity: 1 },
    delay: 1400,
    config: { easing: easings.easeOutCubic },
  });

  return (
    <div
      className={cn(
        'text-center relative desktop:pt-14 px-4 overflow-hidden',
        className,
      )}
    >
      <animated.p className="desktop:text-lg text-base mb-1" style={subtitle}>
        {t`Iraq’s First Crypto Exchange`}
      </animated.p>

      <animated.h1
        className="text-3xl whitespace-normal leading-none desktop:text-6xl desktop:mb-4 py-3 desktop:py-0"
        style={h1}
      >
        {t`Your Gateway to Safe, Simple Crypto`}
      </animated.h1>

      <animated.p
        className="text-content-secondary desktop:text-base text-sm mt-4 desktop:mt-0"
        style={paragraph}
      >
        {t`Trade with confidence on the only exchange fully built for your region.`}
      </animated.p>
    </div>
  );
};
